import React, { Component, useState } from "react";
import BackArrow from "../common/BackArrow";
import { connect } from "react-redux";
import API from "../common/Api";
import { api, headers } from "./../common/server";

import google_calendar from "../assets/google_calendar.svg";

const mapStateToProps = (state) => ({
  banks: state.banks,
  business: state.business,
  member: state.member,
  userProfile: state.member,
  headers: state.headers(),
});

export default connect(mapStateToProps)(
  class IntegrationSettings extends Component {
    state = {
      authCode: null,
    };

    componentDidMount = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const code = queryParams.get('code');
      console.log("code", code)
      if (code) {
         
        API({
          method: "GET",
          url: "google/callback?code=" + code,
          headers: { ...this.props.headers, Accept: "*/*" },
        })
          .then(
            ({ data }) => {
              console.log(data)
              const cleanUrl = window.location.origin + window.location.pathname + "/profile/integration";
              this.setState({ google_token: data.google_token, google_email: data.google_email })
              this.props.dispatch({
                type: "GET_MEMBER",
                data: { ...data.data, google_token: data.google_token,google_email: data.google_email },
              });
              window.$.notify("Business connected to Google Calendar services", "success-alert");
              window.history.replaceState({}, document.title, cleanUrl);
            })
      }


    };

    connectGoogleMeet = async () => {
      window.location.href = api + "/google/login";
    };

    disConnectGoogleMeet = async () => {
      API({
        method: "GET",
        url: "google/discount",
        headers: { ...this.props.headers, Accept: "*/*" },
      })
        .then(
          ({ data }) => {
             
            const cleanUrl = window.location.origin + window.location.pathname + "/profile/integration";
            this.setState({ google_token: null })
            window.$.notify("Business disconnected from Google Calendar services", "success-alert");
            this.props.dispatch({
              type: "GET_MEMBER",
              data: { ...data.data, google_token: null,google_email:null },
            });
            window.history.replaceState({}, document.title, cleanUrl);

          })
    }

    render() {
      return (
        <div className="onboarding-page profile-settings-page">
          <h1 className="form-title dsk"> Integrations </h1>
          <div className="form_step form-page">
            <h1 className="form-title mbl flex center">
              <BackArrow />
              Integrations
            </h1>
            <div className="form-container team-page">
              <div className="layout-grid">
                <div className="card flex" style={{ padding: '24px' }}>
                  <div style={{ padding: '0px 24px 0px 0px' }}>
                    <img src={google_calendar} alt="Google Calendar"></img>
                  </div>
                  <div>
                    <div>
                      <h4 className="title google_head">Google Calendar

                        {this.props.member.google_token ? <span className="connected_google_badge">CONNECTED</span> : ""}
                      </h4>
                      <div className="google_sub_text">To automatically add bookings to your calendar and send virtual meeting links.</div>
                    </div>

                    {this.props.member.google_token ?
                      <>
                        <button onClick={() => { this.disConnectGoogleMeet() }}
                          className="btn secondary google_dark" style={{ margin: "10px 0" }}>Disconnect</button>
                        <small className="google_sub_text">{this.props.member.google_email}</small>
                      </>
                      :
                      <button onClick={() => { this.connectGoogleMeet() }}
                        className="btn default" style={{ margin: "10px 0" }}>Connect</button>}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
